import { FC, memo } from 'react'

import { Text, Button } from '@cash-me/react-components'

import { Infos, Section } from 'components/general-styles/General'
import { Grid, Col } from 'components/grid'
import { Polygon } from 'components/polygon'
import { VideoPlayer } from 'components/video-player'
import useWindowSize from 'hooks/useWindowSize'

import { GuaranteeProps } from './guarantee.model'
import * as S from './styles'

const Guarantee: FC<GuaranteeProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <Section $bg="contrast-medium">
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.Polygons>
            <Polygon
              type="Triangle"
              width={163}
              height={145}
              draw="fill"
              color="#00224B"
              className="filled-polygon"
            />
            <Polygon
              type="Triangle"
              width={163}
              height={145}
              draw="stroke"
              color="#FFFFFF"
              strokeWidth="1"
              className="stroke-polygon"
            />
          </S.Polygons>
          <S.Video>
            <VideoPlayer
              videoUrl="https://www.youtube-nocookie.com/embed/SKdYWR86WSU?controls=0&autoplay=1"
              videoTitle="Empréstimo com Garantia de Imóvel vale a pena?"
              width={327}
              height={194}
              imagePlaceholder={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home-equity/video-home-equity.jpg?updated=230920`}
              alt="Mulher da Cashme explicando sobre o empréstimo com garantia"
            />
          </S.Video>
        </Col>
        <Col col={{ desktop: 5 }} start={{ tablet: 2, desktop: 7 }}>
          <Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase color="var(--colors-neutral-text-contrast-weak)">
              Entenda mais
            </Text>
            <Text as="h2" size="heading3" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              O Empréstimo Online {' '}
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-contrast)">
                é para mim?
              </Text>
            </Text>
            <Text color="var(--colors-neutral-text-contrast-default)">
              Com o Empréstimo Online com garantia, você decide como quer usar o dinheiro. Veja algumas 
              ideias do que você pode fazer com o seu crédito:
            </Text>
            <S.LoanInfos>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body1" color="var(--colors-neutral-text-contrast-default)">
                  Investir em capital de giro para o próprio negócio;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body1" color="var(--colors-neutral-text-contrast-default)">
                  Trocar dívidas caras por uma única mais barata;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body1" color="var(--colors-neutral-text-contrast-default)">
                  Reformar a sua casa ou comprar uma nova;
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon color="var(--colors-cyan-icon-hover)" />
                <Text size="body1" color="var(--colors-neutral-text-contrast-default)">
                  E o que mais você decidir!
                </Text>
              </S.LoanInfosItem>
            </S.LoanInfos>
            <Button
              size="lg"
              onClick={onClick}
              {...(isTablet ? { variants: 'default', iconName: 'arrowRight' } : { variants: 'text-only' })}
            >
              Simular agora
            </Button>
          </Infos>
        </Col>
      </Grid>
    </Section>
  )
})

Guarantee.displayName = 'Guarantee'

export default Guarantee
